module.exports = __webpack_public_path__ + "static/media/manual_02.a4bb4779.jpg";